export async function tryPersistWithoutPromptingUser() {
  if (!navigator.storage?.persisted) {
    return "never";
  }
  let persisted = await navigator.storage.persisted();
  if (persisted === true) {
    return "persisted";
  }
  if (!navigator.permissions?.query) {
    return "prompt"; // It MAY be successful to prompt. Don't know.
  }
  let permission;
  try {
    permission = await navigator.permissions.query({
      name: "persistent-storage",
    });
  } catch (err) {
    console.warn(err);
    return "prompt";
  }
  if (permission.state === "granted") {
    persisted = await navigator.storage.persist();
    if (persisted === true) {
      return "persisted";
    } else {
      throw new Error("Failed to persist");
    }
  }
  if (permission.state === "prompt") {
    return "prompt";
  }
  return "never";
}
